import { useParams } from "react-router-dom";
import { Loading, Error } from "ra-ui-materialui";

import useOneMember from "../../../hooks/useOneMember";
import useOneMemberCI from "../../../hooks/useOneMemberCI";
import MemberProfileBaseView from "../components/MemberProfileBaseView";
//import { useLocale } from "react-admin";
import { useTranslate } from "react-admin";

const TagView = () => {
  const { id } = useParams();
  //  const locale = useLocale();
  const translate = useTranslate();
  const { member: ci, loading: ciLoading, error: ciError } = useOneMemberCI(id);
  const { member, loading, error } = useOneMember(id);

  if (loading || ciLoading) return <Loading />;
  if (error || ciError) return <Error error={error} />;
  const tabs = [
    {
      title: "",
      blocks: [
        {
          title: translate("ra.text.ci.tags"),
          isArray: false,
          datas: [
            {
              key: "tags",
              value: ci.tags, //Come from gid,
              text: translate("ra.text.ci.tags"),
              type: "textarray",
              max: 3,
            },
          ],
        },
      ],
    },
  ];

  return (
    <MemberProfileBaseView
      title={translate("ra.text.ci.tags")}
      tabs={tabs}
      member={member}
      ci={ci}
    />
  );
};

export default TagView;
